<template>
  <div v-if="isReady" class="table">
    <table-header :tableHeader="headerData[headerKey]"></table-header>
    <table-body
      class="table-body"
      :tableData="data"
      :activePage="activePage"
      :totalDataCount="sortedData.length"
      :pageDataCount="pageDataCount"
      :dataKey="headerKey"
    ></table-body>
    <table-pagination
      :totalPageCount="totalPage"
      :totalDataCount="sortedData.length"
      @change-page="setPageData"
    ></table-pagination>
  </div>
</template>

<script>
import TableHeader from "./TableHeader.vue";
import TableBody from "./TableBody.vue";
import TablePagination from "./TablePagination.vue";
import HeaderData from "./tableHeader";
export default {
  components: {TableHeader, TableBody, TablePagination},
  props: {
    tableData: Array,
    headerKey: String,
  },
  data() {
    return {
      headerData: HeaderData,
      isReady: false,
      pageDataCount: 10,
      totalPage: 1,
      data: [],
      sortedData: this.tableData,
      activePage: 1,
      currSortedKey: "",
      sortDirection: -1,
    };
  },
  methods: {
    setTotalPageCount() {
      this.totalPage = Math.ceil(this.tableData.length / this.pageDataCount);
    },
    setPageData(activePage) {
      let data = [];

      for (let i = 0; i < this.pageDataCount; i++) {
        let index = (activePage - 1) * this.pageDataCount + i;
        if (this.sortedData.length > index) {
          data.push(this.sortedData[index]);
        }
      }
      this.activePage = activePage;
      this.data = data;
    },
  },
  watch: {
    tableData() {
      this.data = this.tableData;
      this.sortedData = this.tableData;
      this.setTotalPageCount();
      this.setPageData(1);
    },
  },
  mounted() {
    this.data = this.tableData;
    this.sortedData = this.tableData;
    this.setTotalPageCount();
    this.setPageData(1);
    this.isReady = true;
  },
};
</script>

<style scoped>
.table >>> .table-wrapper {
  display: table;
  table-layout: fixed;
  width: 100%;
}
.table >>> .table-wrapper .table-cell:nth-child(2) {
  width: 5%;
}
.table >>> .table-wrapper .table-cell:nth-child(1) {
  width: 5%;
}
.table >>> .table-wrapper .table-cell:nth-child(3) {
  width: 67%;
}
.table .table-body >>> .table-cell:nth-child(3) {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table >>> .table-cell span {
  font-size: 14px;
}
@media (min-width: 768px) and (max-width: 1280px) {
  .table >>> .table-wrapper .table-cell:nth-child(3) {
    width: 50%;
  }
}
@media (max-width: 767px) {
  .table >>> .table-cell {
    padding: 0.5rem;
  }
  .table >>> .table-cell:nth-child(1) {
    width: 10% !important;
  }
  .table >>> .table-cell:nth-child(2) {
    width: 10% !important;
  }
  .table >>> .table-wrapper .table-cell:nth-child(3) {
    width: 50%;
  }
  .table >>> .table-cell:nth-child(3) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 50%;
  }
}
@media (max-width: 500px) {
  .table >>> .fontS {
    font-size: 12px !important;
  }
  .table >>> .table-wrapper .table-cell:nth-child(3) {
    width: 45%;
  }
}
@media (max-width: 1099px) {
  .table >>> .table-cell:last-child {
    display: none;
  }
  .table >>> .table-cell:first-child {
    display: none;
  }
}
</style>
